import React from "react";
import "./Verticals.css";

// import GIFs (your naming)
import v1 from "../assets/verticals/vertical1.gif";
import v2 from "../assets/verticals/vertical2.gif";
import v3 from "../assets/verticals/vertical3.gif";
import v4 from "../assets/verticals/vertical4.gif";
import v5 from "../assets/verticals/vertical5.gif";
import v6 from "../assets/verticals/vertical6.gif";
import v7 from "../assets/verticals/vertical7.gif";
import v8 from "../assets/verticals/vertical8.gif";
import v9 from "../assets/verticals/vertical9.gif";
import v10 from "../assets/verticals/vertical10.gif";
import v11 from "../assets/verticals/vertical11.gif";
import v12 from "../assets/verticals/vertical12.gif";


const verticals = [
  { name: "E-commerce", img: v1 },
  { name: "FinTech", img: v2 },
  { name: "Healthcare", img: v3 },
  { name: "EdTech", img: v4 },
  { name: "Travel", img: v5 },
  { name: "Real Estate", img: v6 },

  { name: "Food & Beverage", img: v7 },
  { name: "Gaming", img: v8 },
  { name: "SaaS", img: v9 },
  { name: "Logistics", img: v10 },
  { name: "Media", img: v11 },
  { name: "Automotive", img: v12 },
];

export default function Verticals() {
  return (
    <section id="verticals" className="verticals-section">
      <h2 className="verticals-title">Success Across Business Verticals</h2>

      <div className="verticals-grid">
        {verticals.map((item, index) => (
          <div className="vertical-item" key={index}>
            <img src={item.img} alt={item.name} />
            <p>{item.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
}